import axios from "axios";

export const APP_NAME = "Behoused";
export const HOMEPAGE_URL = ""
export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL
axios.defaults.baseURL = BASE_API_URL;
